export default "__VITE_ASSET__EKlrAqYv__"